exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedorGestionOrdenes[data-v-56ecfe3a]{width:100%}.contenedorGestionOrdenes .space-bottom[data-v-56ecfe3a]{margin-bottom:10vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56ecfe3a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/GestionOrdenes/GestionOrdenes.scss
// module id = 970
// module chunks = 0